export enum CourseContentTypeModel {
  Unknown = 0,
  AzureVideo = 1,
  AzureScorm = 2,
  WebexRecording = 3,
  External = 4
}
